import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Skeleton } from '@air/component-skeleton';

import { PublicAnnotationComment } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/PublicAnnotationComment';
import { PublicAnnotationsAvatars } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/components/PublicAnnotationsAvatars';
import { useCanAnnotateCentralizedPublicClip } from '~/components/AnnotationsV2/hooks/useCanAnnotateCentralizedPublicClip';
import { PublicFloatingCommentForm } from '~/components/AnnotationsV2/shared/PublicFloatingCommentForm';
import { RiveVisualizerInner } from '~/components/AssetModalV2/Visualizer/components/RiveVisualizer/RiveVisualizer';
import { centralizedClipAssetsSelector } from '~/store/centralizedClip/selectors';

export const PublicRiveVisualizer = memo(() => {
  const { canEditAnnotation } = useCanAnnotateCentralizedPublicClip();
  const clipAssets = useSelector(centralizedClipAssetsSelector);
  const clipUrl = clipAssets?.original;

  if (!clipUrl) {
    return (
      <div className="flex size-full items-center justify-center">
        <Skeleton width={400} height={400} />
      </div>
    );
  }

  return (
    <RiveVisualizerInner
      AnnotationsAvatars={PublicAnnotationsAvatars}
      AnnotationComment={PublicAnnotationComment}
      FloatingCommentForm={PublicFloatingCommentForm}
      src={clipUrl}
      canAnnotateClip={canEditAnnotation}
    />
  );
});

PublicRiveVisualizer.displayName = 'PublicRiveVisualizer';
